import { ref } from 'vue';

export function createShipmentFormHydrationSlice() {
  const formHydrationSuspended = ref(false);
  /** Hydration bookkeeping only — HTTP POST vs PUT uses persistedStopId. */
  const stopsSyncedOnDeviceApi = ref(false);
  const serverRoutesEmptyAtHydrate = ref(true);
  const serverFieldErrors = ref<Record<string, string>>({});

  function suspendFormHydration() {
    formHydrationSuspended.value = true;
  }

  function resumeFormHydration() {
    formHydrationSuspended.value = false;
  }

  function markServerRoutesPersistedFromForm() {
    serverRoutesEmptyAtHydrate.value = false;
  }

  function clearServerFieldErrors() {
    serverFieldErrors.value = {};
  }

  function setServerFieldErrors(errors: Record<string, string>) {
    serverFieldErrors.value = { ...errors };
  }

  function resetHydrationFlags() {
    stopsSyncedOnDeviceApi.value = false;
    serverRoutesEmptyAtHydrate.value = true;
    clearServerFieldErrors();
  }

  return {
    formHydrationSuspended,
    stopsSyncedOnDeviceApi,
    serverRoutesEmptyAtHydrate,
    serverFieldErrors,
    suspendFormHydration,
    resumeFormHydration,
    markServerRoutesPersistedFromForm,
    clearServerFieldErrors,
    setServerFieldErrors,
    resetHydrationFlags,
  };
}
